import axios from 'axios';

import axiosClient from '../api/axiosClient.js';
import ROUTES from '../api/api_routes.js';

// 🟢 INFRA — client único de autenticação do SPA.
//
// O SPA autentica o CUSTOMER (CPF ou CNPJ + código de acesso por e-mail) — o
// User (backoffice) entra apenas pelas telas ERB do Devise em /admin/users/*.
// Os paths vivem em api/api_routes.js; nunca escreva URL de auth à mão.
//
// Contrato com a API (.docs/0k - 20-plano-login-cpf-cnpj.md, §3.2): a chave do body
// é `document`, com o valor como o usuário digitou (mascarado ou não) — quem
// normaliza é o backend. O parâmetro se chama `documentNumber` só para não
// sombrear `window.document`.

/**
 * Passo 1 do login: pede o envio do código de acesso para o e-mail do
 * customer dono do CPF ou CNPJ (criando o cadastro via Holmes, se necessário).
 *
 * axios "cru" de propósito: o interceptor do axiosClient redireciona em 401,
 * mas aqui erros (documento inválido = 422, reenvio cedo demais ou throttle
 * por IP = 429) são resposta esperada e precisam chegar ao componente para
 * virar mensagem no formulário.
 * @param {string} documentNumber CPF ou CNPJ
 */
function requestAccessCode(documentNumber) {
  return axios.post(
    ROUTES.CUSTOMER_REQUEST_CODE,
    { customer: { document: documentNumber } },
    { headers: { Accept: 'application/json' } },
  );
}

/**
 * Passo 2 do login: autentica com CPF ou CNPJ + código recebido por e-mail.
 * 401 (código errado/expirado) é resposta esperada — axios cru, como acima.
 * @param {string} documentNumber CPF ou CNPJ
 * @param {string} accessCode
 */
function signInCustomer(documentNumber, accessCode) {
  return axios.post(
    ROUTES.CUSTOMER_SIGN_IN,
    { customer: { document: documentNumber, access_code: accessCode } },
    { headers: { Accept: 'application/json' } },
  );
}

/**
 * Encerra a sessão do customer e devolve para a landing pública.
 */
function signOutCustomer() {
  return axiosClient.delete(ROUTES.CUSTOMER_SIGN_OUT).then(() => {
    // O flash é gravado por Customers::SessionsController e chega pela
    // sessão na próxima página, sem sujar a URL.
    window.location.href = '/';
  });
}

const authClient = { requestAccessCode, signInCustomer, signOutCustomer };

export default authClient;
